export default __webpack_public_path__ + "static/aikido-simon-6eed20d4cbd706571e8280e03867d0e5.jpg";